//@ts-ignore images ignore
import { ReactComponent as CableCodeIcon } from '~/images/icons/cable-code.svg';
//@ts-ignore images ignore
import { ReactComponent as CableIcon } from '~/images/icons/cable.svg';
//@ts-ignore images ignore
import { ReactComponent as ReelIcon } from '~/images/icons/reel.svg';
//@ts-ignore images ignore
import { ReactComponent as EquipmentIcon } from '~/images/icons/equipment.svg';
//@ts-ignore images ignore
import { ReactComponent as JumperIcon } from '~/images/icons/jumper.svg';
//@ts-ignore images ignore
import { ReactComponent as ColorCodeIcon } from '~/images/icons/color-code.svg';
//@ts-ignore images ignore
import { ReactComponent as EquipmentCodeIcon } from '~/images/icons/equipment-code.svg';
//@ts-ignore images ignore
import { ReactComponent as FireareasIcon } from '~/images/icons/fireareas.svg';
//@ts-ignore images ignore
import { ReactComponent as FittingsIcon } from '~/images/icons/fittings.svg';
//@ts-ignore images ignore
import { ReactComponent as InsertBlockSizesIcon } from '~/images/icons/insert-block-sizes.svg';
//@ts-ignore images ignore
import { ReactComponent as PackagesIcon } from '~/images/icons/packages.svg';
//@ts-ignore images ignore
import { ReactComponent as RacewayCodeIcon } from '~/images/icons/raceway-code.svg';
//@ts-ignore images ignore
import { ReactComponent as RacewayIcon } from '~/images/icons/raceway.svg';
//@ts-ignore images ignore
import { ReactComponent as StartupSystemsIcon } from '~/images/icons/startup-systems.svg';
//@ts-ignore images ignore
import { ReactComponent as SystemsIcon } from '~/images/icons/systems.svg';
//@ts-ignore images ignore
import { ReactComponent as CableTerminationIcon } from '~/images/icons/cable-termination.svg';
//@ts-ignore images ignore
import { ReactComponent as OverrideIcon } from '~/images/icons/override.svg';
//@ts-ignore images ignore
import { ReactComponent as RenameIcon } from '~/images/icons/rename.svg';
//@ts-ignore images ignore
import { ReactComponent as AnalyzeIcon } from '~/images/icons/analyze.svg';
//@ts-ignore images ignore
import { ReactComponent as IssueComponentIcon } from '~/images/icons/issue-component.svg';
//@ts-ignore images ignore
import { ReactComponent as ProjectIcon } from '~/images/icons/project.svg';
//@ts-ignore images ignore
import { ReactComponent as PurgeDeletesIcon } from '~/images/icons/purge-delete.svg';
//@ts-ignore images ignore
import { ReactComponent as SettingsIcon } from '~/images/icons/settings.svg';
//@ts-ignore images ignore
import { ReactComponent as SecurityIcon } from '~/images/icons/security.svg';
//@ts-ignore images ignore
import { ReactComponent as ProjectUserIcon } from '~/images/icons/project-users.svg';
//@ts-ignore images ignore
import { ReactComponent as CableMarkIcon } from '~/images/icons/cable-mark.svg';
//@ts-ignore images ignore
import { ReactComponent as CableRouteIcon } from '~/images/icons/cable-route.svg';
//@ts-ignore images ignore
import { ReactComponent as JumperTerminationIcon } from '~/images/icons/jumper-termination.svg';
//@ts-ignore images ignore
import { ReactComponent as LinkageIcon } from '~/images/icons/linkage.svg';
//@ts-ignore images ignore
import { ReactComponent as RacewayBarrierIcon } from '~/images/icons/raceway-barrier.svg';
//@ts-ignore images ignore
import { ReactComponent as SeparationGroupIcon } from '~/images/icons/separation-group.svg';
//@ts-ignore images ignore
import { ReactComponent as ServiceLevelIcon } from '~/images/icons/service-level.svg';

export const navbarIcons = {
  cable: CableIcon,
  raceway: RacewayIcon,
  equipment: EquipmentIcon,
  jumper: JumperIcon,
  cablecode: CableCodeIcon,
  racewaycode: RacewayCodeIcon,
  equipmentcode: EquipmentCodeIcon,
  colorcode: ColorCodeIcon,
  reel: ReelIcon,
  firearea: FireareasIcon,
  system: SystemsIcon,
  startupsystem: StartupSystemsIcon,
  package: PackagesIcon,
  fitting: FittingsIcon,
  insertblock: InsertBlockSizesIcon,
  cableterm: CableTerminationIcon,
  analyze: AnalyzeIcon,
  renametags: RenameIcon,
  overrideprimarystatus: OverrideIcon,
  issuecomponents: IssueComponentIcon,
  project: ProjectIcon,
  security: SecurityIcon,
  settings: SettingsIcon,
  purgedeletes: PurgeDeletesIcon,
  useraccount: ProjectUserIcon,
  cablemark: CableMarkIcon,
  via: CableRouteIcon,
  jumperterm: JumperTerminationIcon,
  link: LinkageIcon,
  racewaybarrier: RacewayBarrierIcon,
  separationgroupcompatibility: SeparationGroupIcon,
  servicelevelcompatibility: ServiceLevelIcon,
  termination: CableTerminationIcon,
};
